import * as jsxRuntime from "C:\\Pratik\\ET\\Frontend\\75-hannemanns-hus\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment